import React from 'react';
import { createMenuButton } from '../Alarm/ProcessAlarm';
import ButtonsForTabs from '../Button/ButtonsForTabs';
import './main-frame-tab.css';

interface MainFrameProps {
    namemnemo: string;
}

export interface ButtonConfig {
    title: string;
    className: string;
    style?: React.CSSProperties;
    action?: (namemnemo: string) => void;
}

const buttons: ButtonConfig[] = [
    {
        title: 'Launches a PenZoom window',
        className: 'pen-zoom'
    },
    {
        title: 'Acknowledge Blinking event',
        className: 'acknowledge',
        action: (namemnemo: string) => {
            let ActiveEvents = window.Base.Events.GetActiveEvents().CentumVP.MnemoAlrm[namemnemo].Alarms;
            let ids = [];
            for (const activeElement of ActiveEvents) {
                let hasAck = ((activeElement.NewState >> 2) & 1) == 1;
                if (hasAck) ids.push(activeElement.id);
            }
            if (ids.length != 0) window.Base.Events.AckEvents(ids);
        }
    },
    {
        title: 'Print document',
        className: 'print-document'
    },
    {
        title: 'Select the active generic name set',
        className: 'select-active-generic-name-set'
    }
];

function MainFrameTab(props: MainFrameProps) {
    const { namemnemo } = props;

    const tabRef = React.useRef<HTMLDivElement>(null);

    return (
        <div
            style={{
                height: '24px',
                background: '#dfe3e7',
                border: '1px solid #c8c8c8',
                padding: '2px',
                display: 'flex',
                alignItems: 'center'
            }}
            className="main-frame-tab"
            ref={tabRef}>
            {buttons.map((button: any, index: number) => (
                <ButtonsForTabs
                    key={index}
                    title={button.title}
                    className={button.className}
                    style={button.style}
                    onClick={() => button.action(namemnemo)}
                />
            ))}
        </div>
    );
}

export default MainFrameTab;
